module.exports = __webpack_public_path__ + "spain.png?2ce8ffe491cddd756db0c37e150db416";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spain.png
// module id = 467
// module chunks = 2